import { yupResolver } from '@hookform/resolvers/yup';
import { ICarrierFormMeta, TCarrierFormFieldsName } from '@Modules/admin/archiving/containers/formHandlers/validTransactionInquiry/transactionHistory/carrier/CarrierFormMeta';
import CustomFieldSet from '@Modules/core/components/CustomFieldSet';
import CustomSaveBtn from '@Modules/core/components/form/CustomSaveBtn';
import { ChakraComponents as CC } from '@Modules/core/lib/chakra';
import { TFormUIProps } from '@Modules/core/types/FormUIPropsType';
import displayCustomInputs from '@Shared/utils/displayCustomInputs';
import { getFormFieldsName } from '@Shared/utils/getFormFieldsNames';
import React from 'react';
import { useForm } from 'react-hook-form';

type Props = {
    meta: ICarrierFormMeta,
    data: TCarrierFormFieldsName
} & TFormUIProps;

const CarrierFormUI: React.FC<Props> = ({ onSubmit, isLoading, isSubmitting, meta, data }) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm({ resolver: yupResolver(meta.schema) });

  React.useEffect(() => {
    for(let name in data) {
      setValue(name, data[name]);
    }
  
    return () => {
    }
  }, [data])

  const carrierInformation = React.useMemo(() => getFormFieldsName(meta).slice(0, 11), [meta]);

  const autorisationInformation = React.useMemo(() => getFormFieldsName(meta).slice(11), [meta]);

  return (
    <CC.Box as={'form'} onSubmit={handleSubmit(onSubmit)}>
      
      <CustomFieldSet title={"Donnée Porteur"}>
        <CC.SimpleGrid columns={{ base: 1, lg: 2 }} gridRowGap={4} columnGap={16} my={4}>
            {displayCustomInputs<ICarrierFormMeta>(
            meta,
            register,
            errors,
            isLoading, carrierInformation
            )}
        </CC.SimpleGrid>

      </CustomFieldSet>

      <CustomFieldSet title={"Donnée Autorisation"}>
        <CC.SimpleGrid columns={{ base: 1, lg: 2 }} gridRowGap={4} columnGap={16} my={4}>
            {displayCustomInputs<ICarrierFormMeta>(
            meta,
            register,
            errors,
            isLoading, autorisationInformation
            )}
        </CC.SimpleGrid>

      </CustomFieldSet>

      <CC.HStack my={4} justifyContent={'flex-end'}>
        <CustomSaveBtn isLoading={isLoading} isSubmitting={isSubmitting} />
      </CC.HStack>
    </CC.Box>
  );
};

export default CarrierFormUI;
